<template>
  <div id="pendencias-criticas">
    <section>
      <b-row>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_1 == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  Recomenda-se entrar em contato com nosso suporte e pedir para
                  atualizar a Sincronização.
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_2 == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  Pessoa com acompanhamento recente. Recomenda-se atualizar o
                  cadastro individual.
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_3 == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  Cadastro atualizado há mais de 2 anos. Recomenda-se atualizar
                  o cadastro individual.
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_4 == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  Pessoa com mais de um cadastro/prontuário. Recomenda-se fazer
                  a unificação no PEC ou Centralizador.
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_5 == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  Atualizar o cadastro individual vinculando a uma equipe (eSF,
                  eSFR ou eAP).
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_6 == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  Pessoa com mais de um cadastro/prontuário. Recomenda-se fazer
                  a unificação no PEC ou Centralizador.
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_7.active == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  {{ cidadao.pendencias_criticas.pendencia_7.text }}
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <MaisIndicadoresTabs :cidadao="cidadao" :somente-pendentes="true">
        <template #default="{ pendencias }">
          <b-row v-if="pendencias.length > 0">
            <b-col
              v-for="item in pendencias"
              :key="item.key"
              cols="12"
              lg="12"
              class="mb-3"
            >
              <b-card class="critical-card shadow-sm">
                <div class="d-flex align-items-center">
                  <div class="critical-icon mr-3 is-danger">
                    <i class="icofont-warning-alt" aria-hidden="true"></i>
                  </div>

                  <div class="flex-grow-1">
                    <div class="font-weight-600">
                      {{ item.text }}
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </template>
      </MaisIndicadoresTabs>
      <b-row>
        <b-col
          v-if="cidadao.pendencias_criticas.pendencia_9 == true"
          cols="12"
          lg="12"
          class="mb-3"
        >
          <b-card class="critical-card shadow-sm">
            <div class="d-flex align-items-center">
              <div class="critical-icon mr-3 is-danger">
                <i class="icofont-warning-alt" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <div class="font-weight-600">
                  A data de nascimento no Cadastro Individual está diferente da
                  registrada no módulo Cidadão. É recomendável atualizar os
                  cadastros para que ambas tenham a mesma informação.
                </div>
                <!-- <div class="small text-muted"></div> -->
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PendenciasCriticas',
  props: {
    cidadao: { type: Object, default: () => null },
  },
  computed: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.critical-card {
  border: 1px solid #ffe0e0;
  background: #fff6f6;
}

.critical-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;

  background: #ffe8e8;
  color: #b42318;
  border: 1px solid #ffd1d1;

  &.is-warning {
    background: #fff4df;
    color: #b26a00;
    border: 1px solid #ffe2a8;
  }

  &.is-info {
    background: #eaf3ff;
    color: #1a5bb8;
    border: 1px solid #cfe3ff;
  }
}

.action-link {
  display: inline-block;
  margin-top: 6px;
  font-weight: 600;
}

.font-weight-600 {
  font-weight: 600;
}
</style>
